import React from "react";
import { Route } from "react-router-dom";
import PurchaseRequest from "../../../containers/modules/purchasing/purchase-request";
import AccessControl from "../../../components/utilities/Class/AccessControl";

export default function PurchaseRequestRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="purchase-request"
      index
      element={
        <AccessControl
          name={"Purchase Request List"}
          auth={authUser}
          component={() => <PurchaseRequest />}
        />
      }
    ></Route>
  );
}
